import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { LOGIN_UP } from "../../graphql/mutations/signUp";
import Login from "../../components/Login/Login";
import { useDispatch, useSelector } from "react-redux";
import { loginAction, setError, setLoading } from "../../store/auth/authSlice";
import { useEffect, useState } from "react";
import { RootState } from "../../store/rootReducer";
import { LoadingSpinner, Overlay } from "../AddUserPage/AddUser";
import { toast } from "react-toastify";
import { setUserData } from "../../store/user";
import { clearStorage } from "../../store";

export interface LoginFormValues {
  email: string;
  password: string;
}
const LoginPage = () => {
  const [reloadCount, setReloadCount] = useState<number>(0);
  const [login, { loading }] = useMutation(LOGIN_UP, { errorPolicy: "all" });
  const [formData, setFormData] = useState<LoginFormValues>({
    email: "",
    password: "",
  });
  const isLoggedIn = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(""));
      const response = await login({
        variables: {
          input: { email: formData.email, password: formData.password },
        },
      });
      console.log("RESPONSE", response);
      if (response.data.login.accessToken && response.data.login.id) {
        const {
          accessToken,
          refreshToken,
          organizationId,
          email,
          id,
          tag,
          accountDetails,
          financeDetails,
          settings,
          organization_role_id,
        } = response.data.login;
        console.log("response", response);
        dispatch(loginAction({ accessToken }));
        dispatch(
          setUserData({
            organizationId,
            id,
            email,
            tag,
            accountDetails,
            financeDetails,
            settings,
            organization_role_id,
          })
        );

        navigate("/dashboard/home");
      } else {
        dispatch(setError("Login failed. Please check your credentials."));
      }
    } catch (error: any) {
      console.log(error.message);
      const message = `Login failed. Please check your credentials.`;
      dispatch(setError(message));
      toast.error(message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      {loading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <Login
        handleLogin={handleLogin}
        formData={formData}
        setFormData={setFormData}
        isLoading={loading}
      />
    </>
  );
};
export default LoginPage;
